import React, { useEffect, useState } from "react";
import axios from "axios"; 
import { useParams, useNavigate, Link } from "react-router-dom";
import config from '../../config';

function CategoryDetails() {
    const { id } = useParams(); // Get the category ID from the URL
    const [category, setCategory] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const fetchCategoryDetails = async () => {
        try {
            const response = await axios.get(`${config.BASE_URL}/api/admin/categories/${id}`, { withCredentials: true });
            setCategory(response.data.data);
        } catch (err) {
            setError('Failed to fetch category details');
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchCategoryDetails();
    }, [id]);

    const handleDelete = async () => {
        if (window.confirm('Are you sure you want to delete this category?')) {
            try {
                await axios.delete(`${config.BASE_URL}/api/admin/categories/${id}`, { withCredentials: true });
                navigate('/admin/category'); 
            } catch (err) {
                setError('Failed to delete the category');
            }
        }
    };

    if (loading) return <div className="dashboard"><div className="container"><p>Loading...</p></div></div>;
    if (error) return <div className="dashboard"><div className="container"><p className="error-message">{error}</p></div></div>;
    if (!category) return <div className="dashboard"><div className="container"><p>Category not found</p></div></div>;

    return (
        <div className="dashboard project_detail_wrap">
            <div className="container">
                <h1 className="dash_title">Dashboard</h1>
                <div className="back_btn_wrap">
                    <button className="back-btn" onClick={() => navigate(-1)}>Go Back</button>
                </div>
                <div className="main-section">
                    <div className="projects">
                        <div className="projects-inner">
                            <div className="detail_item">
                                <h2>Category Name</h2>
                                <div className="detail_item_inner">
                                    <p>{category.name}</p>
                                </div>
                            </div>

                            <div className="detail_item">
                                <h2>Description</h2>
                                <div className="detail_item_inner">
                                    <p>{category.description || 'No description provided'}</p>
                                </div>
                            </div>

                            <div className="detail_item">
                                <h2>Created At</h2>
                                <div className="detail_item_inner">
                                    <p>{new Date(category.createdAt).toLocaleDateString()}</p>
                                </div>
                            </div>

                            <div className="detail_item">
                                <h2>Last Updated</h2>
                                <div className="detail_item_inner">
                                    <p>{new Date(category.updatedAt).toLocaleDateString()}</p>
                                </div>
                            </div>
                           
                            <div className="detail_project_btn_wrap">
                                <div className="detail_edit_del">
                                    <div className="btn_item">
                                        <button className="detail_btns delete-btn" onClick={handleDelete}>Delete Category</button>
                                    </div>
                                    <div className="btn_item">
                                        <Link to={`/admin/category-update/${category._id}`} className="update_detail detail_btns">Edit Category</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CategoryDetails;
